import React, { Component, Fragment } from 'react';
import "./toolbar.css";
import Search from "./search"
import Select, { Creatable, Async } from 'react-select';
import renderSelecttree from '../renderField'
import classNames from 'classnames';

import { SingleDatePicker } from 'react-dates'
import 'react-dates/initialize';
import moment from 'moment';
import es from 'moment/locale/es';
import 'react-dates/lib/css/_datepicker.css';
import {api} from 'api'

let estado = [
    {id: true, value: true, label: "Activos"},
    {id: false, value: false, label: "Anulados"}
]

let movimiento = [
    {value: true, label: "Ingreso"},
    {value: false, label: "Egreso"}
]

let movimiento_cliente = [
    {value: false, label: "Debe"},
    {value: true, label: "Haber"}
]

let TipoTransaccion =[
    {value:1, label:'ELECTRONICA'},
    {value:2, label:'CHEQUE'},
    {value:4, label:'DEPOSITO'},
    {value:5, label:'TARJETA'},
    {value:6, label:'EFECTIVO'},
]

const getEmpresas = (search) => {
    let params = {}
    params.search = search
    params.es_principal = false
    return api.get("empresa", params).
        then((data) => {
            if (data) return data.results;
            return [];
        }).catch(() => {
            return [];
        });
};

export default class ToolbarFiltroFechaInterno extends Component {
    state = {
        dateStart: moment.now(),
        focusedStart: false,

        dateEnd: moment.now(),
        focusedEnd: false,

        asyncValue: this.props.asyncValue ? this.props.asyncValue : null,
    }
    componentWillMount() {
    }
  render() {
    return (
      <div className={`col-12 p-0 m-0  row d-flex ${ this.props.justify ? this.props.justify:"justify-content-center justify-content-md-end"} `}>

            <div className="form-group has-feedback col-md-3 col-12 m-0">
                    <div className="col-md-12 p-0 m-2">
                        <label className="t-azul"  htmlFor="producto">Fecha Inicial</label>
                    </div>
                    <SingleDatePicker
                        className="form-control"
                        placeholder={"Fecha Inicio"}
                        date={this.props.dateStart ? moment(this.props.dateStart ) : null}
                        focused={this.state.focusedStart}
                        isOutsideRange={() => false}
                        onDateChange={(value) => {
                        this.setState({dateStart:value})
                        this.props.setDateStart(value)
                        }}
                        onFocusChange={({ focused }) => this.setState({ focusedStart: focused })}
                        numberOfMonths={1}
                        id={"dateStart"}
			readOnly = { true }
                    />
            </div>
            <div className="col-md-3 form-group m-0">
                <div className="col-md-12 p-0 m-2">
                    <label className="t-azul"  htmlFor="producto">Fecha Final</label>
                </div>
                <SingleDatePicker
                        className="form-control"
                        placeholder={"Fecha Final"}
                        date={this.props.dateEnd ? moment(this.props.dateEnd ) : null}
                        focused={this.state.focusedEnd}
                        isOutsideRange={() => false}
                        onDateChange={(value) => {
                           this.setState({dateEnd:value})
                           this.props.setDateEnd(value);
                        }}
                        onFocusChange={({ focused }) => this.setState({ focusedEnd: focused })}
                        numberOfMonths={1}
                        id={"dateStart"}
			readOnly = { true }
                    />
            </div>
            {this.props.setEstado && (
                    <div className="form-group has-feedback col-md-3 col-12 m-0">
                        <div className="col-md-12 p-0 m-2">
                            <label className="t-azul" htmlFor="producto">
                                Estado
                            </label>
                        </div>
                        <Select
                        isClearable={false}
                        className={classNames('react-select-container')}
                        backspaceRemovesValue={false}
                        isSearchable={true}
                        options={estado}
                        placeholder={"Estado"}
                        value={this.props.valorEstado}
                        onChange={this.props.changeEstado}
                            />
                    </div>
                    
                )}
            {this.props.esBalanceCliente && (
                <div className="form-group has-feedback col-md-3 col-12 m-0">
                    <div className="col-md-12 p-0 m-2">
                        <label className="t-azul" htmlFor="producto">
                            Tipo de movimiento
                        </label>
                    </div>
                    <Select
                    isClearable={true}
                    className={classNames('react-select-container')}
                    backspaceRemovesValue={false}
                    isSearchable={true}
                    options={movimiento_cliente}
                    placeholder={"Seleccione"}
                    value={this.props.valorTipoMovimiento}
                    onChange={this.props.changeTipoMovimiento}
                        />
                </div>
            )
            }
            {this.props.esBalanceEmpresa && (
                <Fragment>
                    <div className="form-group has-feedback col-md-3 col-12 m-0">
                        <div className="col-md-12 p-0 m-2">
                            <label className="t-azul" htmlFor="producto">
                                Tipo de movimiento
                            </label>
                        </div>
                        <Select
                        isClearable={true}
                        className={classNames('react-select-container')}
                        backspaceRemovesValue={false}
                        isSearchable={true}
                        options={movimiento}
                        placeholder={"Seleccione"}
                        value={this.props.valorTipoMovimiento}
                        onChange={this.props.changeTipoMovimiento}
                            />
                    </div>
                    <div className="form-group has-feedback col-md-3 col-12 m-0">
                        <div className="col-md-12 p-0 m-2">
                            <label className="t-azul" htmlFor="producto">
                                Forma de pago
                            </label>
                        </div>
                        <Select
                        isClearable={true}
                        className={classNames('react-select-container')}
                        backspaceRemovesValue={false}
                        isSearchable={true}
                        options={TipoTransaccion}
                        placeholder={"Seleccione"}
                        value={this.props.valorFormaPago}
                        onChange={this.props.changeFormaPago}
                            />
                    </div>
                    <div className={`col-lg-3 col-md-3 col-12 align-self-center`}>
                        <div className="col-md-12 p-0 m-2">
                            <label className="t-azul" htmlFor="producto">
                                Empresa
                            </label>
                        </div>
                        <Async
                            isClearable={true}
                            backspaceRemovesValue={false}
                            isSearchable={true}
                            value={this.props.empresa}
                            loadOptions={getEmpresas}
                            getOptionValue={(option) => (option["id"])}
                            getOptionLabel={(option) => (option["nombre"])}
                            type="text"
                            onChange={(e) => {
                                this.props.changeEmpresa(e)
                            }}
                            defaultOptions={true}
                            multi={true}
                            autoload={false}
                            cache={false}
                            className={classNames('react-select-container ')}
                            placeholder="Seleccionar.."
                        />
                    </div>
                </Fragment> 
            )}
            {(this.props.buscar !== undefined) && (
                <div className={`col-lg-3 col-md-3 col-12 align-self-center`}>
                    <Search buscar={this.props.buscar} buscador={this.props.buscador} placeholder={this.props.placeholder} />
                </div>
            )}

      </div>
    )
  }
}
